import { keys } from './keys';
/**
 * Типизированная реализация обхода и маппинга значений объекта
 *
 * @param object - Объект, значения которого надо обойти
 * @param valueMapper - Функция-маппер для преобразования значений объекта
 * @returns Объект с преобразованными значениями
 * @example
 * ```typescript
 * import { objectMap } from '@direct-frontend/stdlib';
 *
 * objectMap(
 *     { foo: 'bar', baz: 'qux' },
 *     (value, key) => {
 *         if (key === 'foo')  {
 *             return value.toUpperCase();
 *         } else {
 *             return value.toLowerCase();
 *         }
 *     },
 * );
 * ```
 */
export function objectMap(object, valueMapper) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    const result = {};
    for (const key of keys(object)) {
        result[key] = valueMapper(object[key], key, object);
    }
    return result;
}
